export const formatDate = (date) => {
    const convertedDate = new Date(date);
    return `${convertedDate?.getDate() < 10 ? "0" + convertedDate?.getDate() : convertedDate?.getDate()}-${convertedDate?.getMonth() < 10 ? "0" + (convertedDate?.getMonth() + 1) : (convertedDate?.getMonth() + 1)}-${convertedDate?.getFullYear()}`
}

export const textCapital = (value) => {
    const stringData = String(value)?.split(" ")
    const data = stringData?.map((value) => {
        if (value !== "" && value !== " " && value !== undefined) {
            return `${value[0]?.toUpperCase()}${value.slice(1, (value.length))?.toLowerCase()}`   
        }
    })
    return data?.join(" ")
}

export const setCookie = (name, storevalue) => {
    document.cookie = name + "=" + storevalue + "; path=/";;
}

export const getCookie = (name) => {
    let get_name = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(get_name) == 0) {
            return c.substring(get_name.length, c.length);
        }
    }

    return "";
}

export const removeCookie = (name) => {
    document.cookie = name + "=";
}
export const deleteAllCookies = () => {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
}
export const parseDateString = (dateString) => {
    if (dateString !== undefined && dateString !== "") {
        const [day, month, year] = dateString?.split('-')?.map(Number);
        return new Date(Date.UTC(year, month - 1, day));
    } else {
        return false
    }
}

export const isTrimmed = (str) => {
    return !(str == str.trim());
  }

  export const reloadWindow = () => {
    return window.location.reload();
}
export const reloadWindowToPath = (pathtoload) => {
    return window.location.href = pathtoload;
}